//
// Initialize plugins and behaviors on document ready
//

$(function () {

    masonry.init()

    navbar.init()

    AOS.init()

    switchButton.init()

    infobulle.init()

    buttonCard.init()

    swiper.init()

    modalAcess.init()

    voletContent.init()

    bntReturn.init()

    sidebarNav.init()

    carouselSlider.init()

    tabList.init()

    flipCard.init()

    stickyHeader.init()

    dropdownMenu.init()

    inputBtn.init()

    scrollSummary.init()

    // telInput.init()

    //  tooltip.init()

    //  spinButton.init()


})


var masonry = {
    init: function () {
        $('.grid').masonry({
            transitionDuration: 0,
            itemSelector: ".grid-item",
            fitWidth: true,
            gutter: 20
        });
    }
}

//
// Add extra behavior to the navbar
//

var navbar = {
    init: function () {
        if (!window.utils.isMobile()) {
            this.initDropdownHover()
        }
    },
    // show/hide dropdown on hover
    initDropdownHover: function () {
        var $dropdowns = $('.navbar .dropdown')
        $dropdowns.each(function (index, item) {
            var $item = $(this)

            $item.hover(function () {
                $item.addClass("show")
                $item.find("> .dropdown-toggle").attr("aria-expanded", true)
                $item.find("> .dropdown-menu").addClass("show")
            }, function () {
                $item.removeClass('show')
                $item.find("> .dropdown-toggle").attr("aria-expanded", false)
                $item.find("> .dropdown-menu").removeClass("show")
            })
        })
    },

}


//
// Extra Helpers
//

window.utils = {
    isMobile: function () {
        if (window.innerWidth <= 992) {
            return true
        } else {
            return false
        }
    }
}

//
// cartes de choix
//

// à supprimer

var buttonCard = {
    init: function () {
        $('.a-btnCard').click(function () {
            $(this).toggleClass('');
        })
    }
}

//
// Switch button
//

var switchButton = {

    init: function () {
        $('.a-switch').click(function (evt) {

            let el = evt.target;

            if (el.getAttribute("aria-checked") == "true") {
                el.setAttribute("aria-checked", "false");
            } else {
                el.setAttribute("aria-checked", "true");
            }

        })
    }
}




//
// disparition de l'infobulle au clic sur le bouton de fermeture
//

// à supprimer

var infobulle = {
    init: function () {
        $('.openInfobulle').on("mouseleave", function () {
            $(this).next().hide(200);
        });
        $('.openInfobulle').on("mouseenter", function () {
            $(this).next().show(200);
        });
        $('.openInfobulle').focus(function () {
            $(this).next().show(200);
        });
        $('.closeInfobulle').focus(function () {
            $('.m-infobulle').hide(200);
        });
    }
}


//
// swiper
//

// à supprimer ? -Vérifier

var swiper = {
    init: function () {
        $("[data-toggle='swiper']").each(function (index, item) {
            new Swiper(item, $(item).data('options'))
        })
    }
}


//
// switch focus  between close & button - forbidden focus to the container of modal
//
var modalAcess = {
    init: function () {
        $(document).ready(function () {
            //            $('#m-findIdentifiantHelpModalId, #o-dragAndDropModalId').on('shown.bs.modal', function () {
            //                $('.getFocus').trigger('focus');
            //            });
            //            $('#m-findIdentifiantHelpModalId, #o-dragAndDropModalId').focus(function () {
            //                $('.getFocus').trigger('focus');
            //            });
            $('.modal').on('shown.bs.modal', function () {
                $('.getFocus').trigger('focus');
            });
            $('.modal').focus(function () {
                $('.getFocus').trigger('focus');
            });
        })
    }
}


//
// Volet button
//

// pas présent sur l'espace bénéficaire ni assurance. à vérifier sur indemnisation

var voletContent = {
    init: function () {

        var countTime = 0;
        var header = $('.o-voletContent');
        var buttonInfo = $('.a-btn.-languette');
        if (!header.hasClass("visible")) {
            var TimeInterval = setInterval(function () {
                ++countTime;
                header.addClass('visible');
                buttonInfo.attr('aria-expanded', 'true');
                $('.o-voletContent__boxText').show();
                $('.o-voletContent__closeButton').show();
                if (countTime >= 2) {
                    clearInterval(TimeInterval);
                    header.removeClass('visible');
                    buttonInfo.attr('aria-expanded', 'false');
                    $('.o-voletContent__boxText').hide();
                    $('.o-voletContent__closeButton').hide();
                }
            }, 4000);
        }
        buttonInfo.on('click', function () {
            header.toggleClass('visible');
            if (header.hasClass('visible')) {
                buttonInfo.attr("aria-expanded", "true");
                $('.o-voletContent__boxText').show();
                $('.o-voletContent__closeButton').show();
            } else {
                buttonInfo.attr("aria-expanded", "false");
                setTimeout(function () {
                    $('.o-voletContent__boxText').hide();
                    $('.o-voletContent__closeButton').hide();
                }, 500);
            }

        })
        $('.a-btn.getCloseHelp').on('click', function () {
            $('.o-voletContent').removeClass('visible');
            $('.a-btn.-languette').attr("aria-expanded", "false");
            setTimeout(function () {
                $('.o-voletContent__boxText').hide();
                $('.o-voletContent__closeButton').hide();
            }, 500);

        })
    }
}


// vérifier sur les projets qui utilise common feature avec Abdelkrim - pas d'impact sur benef.

var bntReturn = {
    init: function () {
        $(document).ready(function () {
            $("[id*='return']").click(function (event) {
                event.preventDefault();
                window.location.href = "${backURL}";
            });
        })
    }
}



var sidebarNav = {
    init: function () {
        // $('.sidebarNavOpen').on('click', function(){
        //     $('.m-sidebarNav').addClass('active');
        //     $('.overlay').addClass('active');

        //     $('html').addClass('overflow-hidden');
        // })

        // $('.sidebarNavClose, .overlay').on('click', function(){
        //     $('.m-sidebarNav').removeClass('active');
        //     $('.overlay').removeClass('active');

        //     $('html').removeClass('overflow-hidden');
        // })

        $(document).on('click', '.sidebarClose', function () {
            $('.modal-backdrop').remove();
            $('#sidebarNav').modal('hide');
        });

    }
}

// Pas présent sur beneft, vérifier sur les autres projets. 

var carouselSlider = {
    init: function () {
        $('.carousel-indicators li').on('click', function () {
            $(this).attr('aria-selected', 'true');
            $(this).attr('tabindex', "0");
            $('.carousel-indicators li').not(this).attr('aria-selected', 'false');
            $('.carousel-indicators li').not(this).attr('tabindex', "-1");
        })

        $('.carousel-indicators li').keydown(function (event) {
            var nextElement = null;
            switch (event.key) {
                case "ArrowLeft":
                    var leftElement = null
                    if (this.previousElementSibling === null) {
                        leftElement = this.parentElement.lastElementChild;
                    } else {
                        leftElement = this.previousElementSibling;
                    }
                    nextElement = leftElement;
                    break;
                case "ArrowRight":
                    var rightElement = null;
                    if (this.nextElementSibling === null) {
                        rightElement = this.parentElement.firstElementChild;
                    } else {
                        rightElement = this.nextElementSibling;
                    }
                    nextElement = rightElement;
                    break;
                default: return;
            }
            nextElement.focus();
            nextElement.classList.add('active');
            nextElement.setAttribute('tabindex', 0);
            nextElement.setAttribute('aria-selected', 'true');

            this.setAttribute('aria-selected', 'false');
            this.setAttribute('tabindex', -1);
            this.classList.remove('active');
        })

    }
}

// composant déprécié - à supprimer plus tard. - pas présent sur benef privée et publique

var tabList = {
    init: function () {
        $('.m-signatureNav li a').on('click', function () {
            $(this).attr('aria-selected', 'true');
            $(this).attr('tabindex', "0");
            $('.m-signatureNav li a').not(this).attr('aria-selected', 'false');
            $('.m-signatureNav li a').not(this).attr('tabindex', "-1");
        })

        $('.m-signatureNav li').keydown(function (event) {
            var nextElement = null;
            switch (event.key) {
                case "ArrowLeft":
                    var leftElement = null
                    if (this.previousElementSibling === null) {
                        leftElement = this.parentElement.lastElementChild;
                    } else {
                        leftElement = this.previousElementSibling;
                    }
                    nextElement = leftElement;
                    break;
                case "ArrowRight":
                    var rightElement = null;
                    if (this.nextElementSibling === null) {
                        rightElement = this.parentElement.firstElementChild;
                    } else {
                        rightElement = this.nextElementSibling;
                    }
                    nextElement = rightElement;
                    break;
                default: return;
            }
            nextElement.firstElementChild.focus();
            nextElement.firstElementChild.classList.add('active');
            nextElement.firstElementChild.setAttribute('tabindex', 0);
            nextElement.firstElementChild.setAttribute('aria-selected', 'true');

            this.firstElementChild.setAttribute('aria-selected', 'false');
            this.firstElementChild.setAttribute('tabindex', -1);
            this.firstElementChild.classList.remove('active');
        })

    }
}

var telInput = {
    init: function () {
        var errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
        var input = document.querySelector("#phone");
        var iti = intlTelInput(input, {
            initialCountry: "fr",
            preferredCountries: ["fr", "us", "ru", "de", "es"],
            separateDialCode: false,
            utilsScript:
                "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
        });
        input.addEventListener('blur', function () {
            if (input.value.trim()) {
                if (iti.isValidNumber()) {
                    console.log("hide");
                } else {
                    input.classList.add("error");
                    var errorCode = iti.getValidationError();
                    var errorMsg = errorMap[errorCode];
                    console.log(errorMsg);
                }
            }
        });

    }
}

var flipCard = {
    init: function () {
        $(".m-flipCard__inner__face.-back").hide();
        $('.flipCardFlip').on('click', function () {
            $(this).parents(".m-flipCard").addClass('isFlipped');
            $(this).parents(".m-flipCard .m-flipCard__inner__face.-front").delay(1000).fadeOut();
            $(this).parents(".m-flipCard__inner__face.-front").siblings().delay(100).fadeIn();
        })
        $('.flipCardFlipBack').on('click', function () {
            $(this).parents(".m-flipCard").removeClass('isFlipped');
            $(this).parents(".m-flipCard .m-flipCard__inner__face.-back").delay(1000).fadeOut();
            $(this).parents(".m-flipCard__inner__face.-back").siblings().delay(100).fadeIn();
        })
    }
}

var stickyHeader = {
    init: function () {
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('.o-header').outerHeight();

        $(window).scroll(function (event) {
            didScroll = true;
        });

        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(this).scrollTop();

            if (Math.abs(lastScrollTop - st) <= delta)
                return;


            if (st > lastScrollTop && st > navbarHeight) {
                $('.o-header').addClass('-navUp');
            } else {
                if (st + $(window).height() < $(document).height()) {
                    $('.o-header').removeClass('-navUp');
                }
            }

            lastScrollTop = st;
        }
    }
}

// Utilisé pour le sous-menu de l'esapce publique.

var dropdownMenu = {
    init: function () {
        $('.dropdown').on('show.bs.dropdown', function () {
            $('body').addClass("nav-overlay");
        })
        $('.dropdown').on('hide.bs.dropdown', function () {
            $('body').removeClass("nav-overlay");
        })
    }
}



//Gestion du bouton de retour au sommaire;
 
var scrollSummary = {
    init: function () {

        if ($('.m-navigationToSummary').length) {
            window.onscroll = function () {
                if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                    $('.m-navigationToSummary').show(500);
                } else {
                    $('.m-navigationToSummary').hide(500);
                }
            }
        }
    }
}


var inputBtn = {
    init: function () {
        let textInput = $('.-inputButton .a-fieldText');
        let btnInput = $('.a-btn.-icon');

        //on cache le bouton par défaut
        btnInput.hide();

        // détection du texte dans le champ de saisie pou faire apparaitre le bouton
        textInput.on("input", function () {
            if ($(this).val() != "") {
                $(this).next().show();
            } else {
                $(this).next().hide();
            }
        });

        btnInput.on("click", function () {
            $(this).prev().val("");
            $(this).hide();
        })
    }
}

